import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@bufferapp/ui/Icon';
import { Text } from '@bufferapp/ui';
import styled from 'styled-components';
import * as Colors from '@bufferapp/ui/style/colors';

const Message = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${Colors.grayDark};
  text-align: center;
  width: ${(props) => (props.onlyAllowsVerticalVideo ? '100px' : '120px')};
  svg {
    margin-bottom: ${(props) => (props.showText ? '4px' : '0px')};
  }
  p {
    margin: 4px 0;
    line-height: 16px;
    max-width: 80px;
  }
  span {
    color: ${Colors.blue};
  }
  &:hover {
    svg {
      fill: ${Colors.blue};
    }
  }
`;

const SmallerText = styled(Text)`
  font-size: 12px;
`;

const UploadMessage = ({
  showMessage,
  isHovering,
  isImageFirst,
  onlyAllowsVerticalVideo,
}) => {
  const iconColor = isHovering ? Colors.blue : '';
  const iconSize = 'large';
  const attachmentText = onlyAllowsVerticalVideo ? 'video' : 'file';
  return (
    showMessage && (
      <Message
        onlyAllowsVerticalVideo={onlyAllowsVerticalVideo}
        showText={showMessage}
      >
        <Image size={iconSize} color={iconColor} />
        {isImageFirst && (
          <Text type="p">
            Drag and drop or <Text>select a {attachmentText}</Text>
          </Text>
        )}
        {!isImageFirst && (
          <SmallerText type="p">
            Drag and drop or <Text>select a {attachmentText}</Text>
          </SmallerText>
        )}
      </Message>
    )
  );
};

UploadMessage.propTypes = {
  showMessage: PropTypes.bool,
  isHovering: PropTypes.bool,
  isImageFirst: PropTypes.bool,
  onlyAllowsVerticalVideo: PropTypes.bool.isRequired,
};

UploadMessage.defaultProps = {
  showMessage: true,
  isHovering: false,
  isImageFirst: false,
};

export default UploadMessage;
